import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, TextKey } from '@mews-commander/enums';
import { GuideLinkButton, PageLayout, useBreadcrumbs, useTabs } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';
import { DateTimeUtils } from '@mews/framework';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Finance/Cashier/_layout/$cashierId')({
    component: () => <PageComponent />,
    loader: async ({
        params: { cashierId },
        context: {
            ensureQueryData,
            localizeText,
            globalization: { timezone, dateTimeLocalizationInfo },
        },
    }) => {
        const [shiftDetails, cashiers] = await Promise.all([
            ensureQueryData('cashiers', 'getShift', {
                cashierId,
            }),
            ensureQueryData('cashiers', 'getAll', {
                cashierIds: [cashierId],
            }),
        ]);

        const date = DateTimeUtils.dateTimeUtcStringToDateTimeString(
            shiftDetails.startUtc,
            dateTimeLocalizationInfo,
            timezone
        );

        const cashierName = cashiers.cashiers?.[0].name || '';

        return {
            title: () => localizeText({ textKey: TextKey.CashierShiftFromFull, substitutes: { cashierName, date } }),
        };
    },
    staticData: {
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
    },
});

const PageComponent = () => {
    const breadcrumbs = useBreadcrumbs();

    const actions = <GuideLinkButton guideLink={createGuideLink(ArticlePath.WhatIsAccountingConfiguration)} />;

    const tabs = useTabs('/$currentEnterpriseId/Finance/Cashier/$cashierId', ['Detail', 'PastShifts']);

    return (
        <PageLayout padded actions={actions} tabs={tabs} breadcrumbs={breadcrumbs}>
            <Outlet />
        </PageLayout>
    );
};
